module.exports = __webpack_public_path__ + "static/footer-1-87a07234cdd21157038da5f3ece67834.jpg";